import React from 'react';
import styled from 'styled-components';
import { OrderSummaryAmount, OrderSummaryProductName, OrderSummaryProducTotalAmount, ProductName } from '../../typography';
import { formatCurrency } from '../../../utils';

interface ProductInterace {
  product: {
    _id: string;
    name: string;
    units: {
      type: string;
      price: string;
      quantity?: string | number
    }[];
    images: string[];
  };
}

const Product = ({
  product
}: ProductInterace) => {
  return (
    <>
        { 
          product.units.map((unit) => {
            if (!unit.quantity || Number(unit.quantity) < 1) {
              return null;
            }
            return (
              <Container>
                <Thumbnail>
                  <img src={product.images[0]} />
                </Thumbnail>
                <Details>
                  <OrderSummaryProductName>
                    {product.name.toUpperCase()} - {unit.type.toUpperCase()}
                  </OrderSummaryProductName>
                  <OrderSummaryProductName>
                  {formatCurrency(unit.price)} x {unit.quantity?.toString().toUpperCase()}
                  </OrderSummaryProductName>
                </Details>
                <Amount>
                  <OrderSummaryProducTotalAmount>
                    {formatCurrency(Number(unit.price) * Number(unit.quantity))}
                  </OrderSummaryProducTotalAmount>
                </Amount>
              </Container>
            )
          })
        }
    </>
  )
} 

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;
  padding: 0.5rem 0rem;
`;


const Thumbnail = styled.div`
  height: 48px;
  
  img {
    height: inherit;
    object-fit: cover;
  }
`;

const Details = styled.div `
  flex: 1;
  p {
    margin: 0 0;
    padding: 0rem 0.5rem;
  }
`;

const Amount = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
   p {
    margin: 0 0;
  }
`;


export default Product;